module.exports = __webpack_public_path__ + "static/media/Control-filled.c8000202.svg";